import { render, staticRenderFns } from "./trades.vue?vue&type=template&id=88068bc4&scoped=true"
import script from "./trades.vue?vue&type=script&lang=js"
export * from "./trades.vue?vue&type=script&lang=js"
import style0 from "./trades.vue?vue&type=style&index=0&id=88068bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88068bc4",
  null
  
)

export default component.exports